module.exports = __webpack_public_path__ + "img/play.1ddedcb4.svg";